import type { Tables } from "@packages/db/schema";
import type { InferInsertModel } from "drizzle-orm";

export * from "./db";
export * from "./types";

export function getServiceCategory(service: InferInsertModel<Tables["deal"]>["service"]): "cleaning" | "moving" | null {
  switch (service) {
    // Städning (cleaning)
    case "byggstadning": // construction cleaning
    case "flyttstadning": // move-out cleaning
    case "sanering": // sanitation / remediation
    case "storstadning": // deep cleaning
    case "visningstadning": // viewing/showing cleaning
    case "ovrig_stadning": // other cleaning
      return "cleaning";

    // Flytt (moving)
    case "bortforsling": // hauling / removal
    case "packhjalp": // packing help
    case "barhjalp": // carrying help
    case "flytthjalp": // moving help
    case "kontorsflytt": // office move
    case "pianoflytt": // piano move
    case "ovrig_flytt": // other moving
      return "moving";

    default:
      return null;
  }
}

export function camelCaseToSnakeCase(str: string) {
  return str.replace(/([A-Z])/g, "_$1").toLowerCase();
}

export function snakeCaseToCamelCase(str: string) {
  return str.replace(/(_[a-z])/g, (match) => match.toUpperCase().replace("_", ""));
}

export function snakeCaseToPascalCase(str: string) {
  return str
    .replace(/(_[a-z])/g, (match) => match.toUpperCase().replace("_", ""))
    .replace(/^[a-z]/, (match) => match.toUpperCase());
}

export function round(value: number, decimals: number) {
  if (decimals <= 0) return Math.round(value);
  return Number.parseFloat(value.toFixed(decimals));
}

export function formatFileSize(bytes: bigint | number): string {
  const units = ["B", "KB", "MB", "GB", "TB"];
  let size = typeof bytes === "bigint" ? Number(bytes) : bytes;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }
  return `${round(size, 2)} ${units[unitIndex]}`;
}

export function formatCurrency(amount: number | string) {
  const formatter = new Intl.NumberFormat("sv-SE", {
    style: "currency",
    currency: "SEK",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return formatter.format(typeof amount === "number" ? amount : Number.parseFloat(amount));
}